import { usePortal } from '../../auth/sessionContext'
import { presentation } from '../../portalMode'
import { DashboardPage } from './DashboardPage'
import { ServiceHome } from './ServiceHome'

/**
 * One route, two homes.
 *
 * The only place in the application that branches on the portal mode to choose
 * a component. Everywhere else the mode adjusts emphasis inside a shared
 * component, because two implementations of the wallet would be two things to
 * fix when the wallet is wrong.
 *
 * A home page earns the exception: what a business opens the portal for and
 * what a development shop opens it for are different pages, not the same page
 * with different padding.
 */
export function HomePage() {
  const { membership } = usePortal()
  return presentation(membership).isService ? <ServiceHome /> : <DashboardPage />
}
